import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.travelCustomReservation.replace(appPath.travel, ''),
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'travelCustomReservation' */ './component')],
			render: ([TravelCustomReservation]) => <TravelCustomReservation />,
		},
	],
};

export default routes;
